import { ClipLoader } from 'react-spinners';

// Focused detail view for one looked-up code. Replaces the modal body when
// a code is inspected (CodeSearchModal owns the swap); purely
// presentational — evidence state arrives via `result` and every action is
// a callback.
export default function CodeLookupDetail({
    hit,
    result,
    onList,
    backLabel,
    onBack,
    onCheckEvidence,
    onAdd,
    onBrowse,
}) {
    return (
        <div className="code-lookup-detail">
            <button className="code-lookup-back" onClick={onBack}>
                &larr; {backLabel}
            </button>

            <div className="code-browser-node">
                <span className="code-browser-node-code">{hit.code}</span>
                <span className="code-browser-node-desc">{hit.description}</span>
                <span className={`code-badge ${hit.billable ? 'code-badge--billable' : 'code-badge--header'}`}>
                    {hit.billable ? 'Billable' : 'Header'}
                </span>
            </div>

            {hit.ancestors?.length > 0 && (
                <div className="code-search-hit-crumb">
                    {hit.ancestors.map(a => a.description).join(' › ')}
                </div>
            )}

            <div className="code-lookup-facts">
                {hit.pdgm?.clinical_group
                    ? <>Clinical group: {hit.pdgm.clinical_group}
                        {hit.pdgm.acceptable_primary
                            ? ' · acceptable as primary'
                            : ' · not acceptable as primary'}</>
                    : 'Not acceptable as primary under PDGM'}
                {hit.pdgm?.comorbidity_subgroup && (
                    <span className="dx-comorbidity-chip">
                        PDGM comorbidity: {hit.pdgm.comorbidity_subgroup}
                    </span>
                )}
            </div>

            {result?.status === 'pending' && (
                <div className="code-search-status">
                    <ClipLoader size={12} /> Searching documents for
                    supporting evidence&hellip;
                </div>
            )}
            {result?.status === 'found' && (
                <div className="code-lookup-evidence">
                    &ldquo;{result.evidence}&rdquo;
                    <span className="code-lookup-source">
                        {' '}&mdash; {result.document}
                        {result.page ? `, p. ${result.page}` : ''}
                    </span>
                </div>
            )}
            {result?.status === 'not_found' && (
                <div className="code-lookup-evidence code-lookup-evidence--missing">
                    No supporting evidence found in the uploaded documents.
                </div>
            )}
            {(result?.status === 'timeout' || result?.status === 'error') && (
                <div className="code-lookup-evidence code-lookup-evidence--missing">
                    Evidence search {result.status === 'error' ? 'failed' : 'timed out'}.
                    <button className="code-browser-btn" onClick={onCheckEvidence}>
                        Retry
                    </button>
                </div>
            )}

            <div className="code-lookup-actions">
                {onList ? (
                    <span className="code-search-hit-hint">Already on the code list</span>
                ) : (
                    <>
                        {!result && (
                            <button className="code-browser-btn" onClick={onCheckEvidence}>
                                Check evidence in documents
                            </button>
                        )}
                        <button
                            className="code-browser-btn code-browser-btn--select"
                            onClick={onAdd}
                        >
                            Add to case
                        </button>
                    </>
                )}
                <button className="code-browser-btn" onClick={onBrowse}>
                    View in hierarchy
                </button>
            </div>
        </div>
    );
}
